export const zodMsg: { [key: string]: string } = {
  required: 'This field is required',
}
